module.exports = __webpack_public_path__ + "img/1.4284a19a.webp";